var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNewProjectAiAssistantWhite = function SvgIconNewProjectAiAssistantWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.7,
    d: "m11.126 4.757 4.223 4.194m.856-7.644 2.485 2.465c.412.408.413 1.07.004 1.48L5.291 18.689a1.06 1.06 0 0 1-1.496.004L1.31 16.228a1.043 1.043 0 0 1-.004-1.48L14.709 1.312a1.06 1.06 0 0 1 1.496-.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M4.406 1.253a.1.1 0 0 1 .188 0l.835 2.259a.1.1 0 0 0 .06.059l2.258.835a.1.1 0 0 1 0 .188l-2.259.835a.1.1 0 0 0-.059.06l-.835 2.258a.1.1 0 0 1-.188 0l-.835-2.259a.1.1 0 0 0-.06-.059l-2.258-.835a.1.1 0 0 1 0-.188l2.259-.835a.1.1 0 0 0 .059-.06zM15.906 13.254a.1.1 0 0 1 .188 0l.7 1.893a.1.1 0 0 0 .06.059l1.893.7a.1.1 0 0 1 0 .188l-1.894.7a.1.1 0 0 0-.059.06l-.7 1.893a.1.1 0 0 1-.188 0l-.7-1.894a.1.1 0 0 0-.06-.059l-1.892-.7a.1.1 0 0 1 0-.188l1.893-.7a.1.1 0 0 0 .059-.06z"
  }))));
};
export default SvgIconNewProjectAiAssistantWhite;